import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { resumeLink, setFlash } from '../features/bank-feeds/plaidFlow';
import { formatApiError } from '../utils/errorMessage';

// Return page for OAuth banks (PLAID_REDIRECT_URI, e.g. https://elonest.com/plaid/oauth).
export default function PlaidOAuth() {
  const navigate = useNavigate();
  const started = useRef(false);
  const [message, setMessage] = useState('Finishing your bank sign-in...');

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    resumeLink(window.location.href)
      .then((msg) => { setFlash(msg); navigate('/bank-feeds', { replace: true }); })
      .catch((e) => setMessage(formatApiError(e, 'Could not finish the bank sign-in. It may have expired; start again from Bank Feeds.')));
  }, [navigate]);

  return (
    <div className="max-w-lg mx-auto p-6">
      <h1 className="text-xl font-semibold mb-2">Bank sign-in</h1>
      <p className="text-gray-700">{message}</p>
      <button type="button" className="mt-4 px-4 py-2 rounded bg-blue-600 text-white" onClick={() => navigate('/bank-feeds')}>Back to Bank Feeds</button>
    </div>
  );
}
